import {verifiedFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'

type UpdateIssueIssueTypeBulkRequestBase = {
  ids: string[]
}

type UpdateIssueIssueTypeBulkRequestWithIssueTypeId = UpdateIssueIssueTypeBulkRequestBase & {
  issueTypeId: string
}

export type UpdateIssueIssueTypeBulkRequest = UpdateIssueIssueTypeBulkRequestWithIssueTypeId

type UpdateIssueIssueTypeBulkResponseData = {
  updateIssuesBulk: {
    jobId: string
  }
}

export type UpdateIssueIssueTypeBulkResponse = GraphQLResponse<UpdateIssueIssueTypeBulkResponseData>

export async function apiUpdateIssueIssueTypeBulk(
  request: UpdateIssueIssueTypeBulkRequest,
): Promise<UpdateIssueIssueTypeBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const init: JSONRequestInit = {
    method: 'POST',
    body: request,
  }
  const response = await verifiedFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueIssueTypeBulkResponse>
}
